import {
  ProfitsLocalCache,
  WSProfitsResponse,
} from "src/Modules/Arbitrage/types";

export const initialState: ProfitsLocalCache = new Map();

export const arbitrageOrderBooksReducer = (
  state: ProfitsLocalCache,
  action: WSProfitsResponse
): ProfitsLocalCache => {
  console.log("Arbitrage OrderBooks Action:", action);

  switch (action.action) {
    case "SNAPSHOT":
      return new Map(action.data.map((item) => [item.id, item]));
    case "UPDATE":
      if (state) {
        const updatedState = new Map(state);
        updatedState.set(action.id, action.data);
        const sortedState = new Map(
          [...updatedState.entries()].sort(
            ([, a], [, b]) => b.maxProfit - a.maxProfit
          )
        );
        return sortedState;
      }
      return state;
    case "DELETE":
      if (state) {
        const updatedState = new Map(state);
        updatedState.delete(action.id);
        return updatedState;
      }
      return state;
    default:
      return state;
  }
};
